import styled from "styled-components";
import { BORDER_COLOR, PRIMARY_COLOR, PRIMARY_TEXT_COLOR } from "../../constants";
import { StyledButton } from "../../components/common/StyledButton";
import { useNavigate } from "react-router-dom";

const RecordKeepingCompliancePage = () => {
  const navigate = useNavigate();
  const handleBack = () => {
    navigate(-1);
  };
  return (
    <Container>
      <TitleText>18 U.S.C. 2257 Record-Keeping Requirements Compliance Statement</TitleText>
      <Text>
        In compliance with the Federal Labeling and Record-Keeping Law (also known as 18 U.S.C. 2257), all content generated on UncensoredAI is subject to the following record-keeping requirements.
      </Text>
      <Text>
        <b>Record-Keeping Requirements:</b>
        <br />
        All AI-generated images on our platform are created through computational processes and do not depict actual human beings. Therefore, no records are required to be maintained under 18 U.S.C. 2257 for this content.
      </Text>
      <Text>
        <b>Responsibility Statement:</b>
        <br />
        While the content generated on UncensoredAI is entirely synthetic and created by artificial intelligence, we are committed to maintaining responsible practices. We prohibit the creation of content that violates any laws or regulations, including those related to the depiction of minors.
      </Text>
      <Text>
        <b>Content Verification:</b>
        <br />
        Our platform employs various technological measures to ensure that content generated adheres to our terms of service and legal requirements. These measures include both automated systems and human review processes.
      </Text>
      <Text>
        <b>Reporting Violations:</b>
        <br />
        If you believe any content on our platform violates our terms of service or any applicable laws, please report it immediately through our reporting system or contact us at hello@TheUncensored.AI.
      </Text>
      <Text>
        <b>Compliance Contact:</b>
        <br />
        For any questions regarding our compliance with 18 U.S.C. 2257 or any other legal requirements, please contact our compliance team at Hello@TheUncensored.AI.
      </Text>
      <Text>
        This statement was last updated on {new Date().toLocaleDateString()}.
      </Text>
      <AcceptButton onClick={handleBack}>OK</AcceptButton>
    </Container>
  );
};

const Container = styled.div`
  display: flex;
  flex-direction: column;
  padding: 64px;

  border: 1px solid ${BORDER_COLOR};

  max-width: 400px;

  position: absolute;
  left: 50%;
  transform: translate(-50%, -0%);
`;

const Text = styled.div`
  font-size: 16px;
  color: ${PRIMARY_TEXT_COLOR};
  text-align: justify;
  margin-bottom: 16px;
`;

const TitleText = styled(Text)`
  font-size: 24px;
`;

const AcceptButton = styled(StyledButton)`
  border-color: ${PRIMARY_COLOR};
`;

export default RecordKeepingCompliancePage; 